<template>
  <div class="all-discuss-list">
    <loading v-if="loading"></loading>
    <div class="content" v-if="!loading">
      <!-- <div class="header">
        <van-nav-bar title="全部评论" left-arrow @click-left="onClickLeft">
        </van-nav-bar>
      </div> -->
      <div class="comment-box" v-if="!loading">
        <div class="comment-list" v-if="CommentNum !== 0">
          <van-list v-model="listLoading" :finished="finished" finished-text="没有更多了..." @load="getCommentList" :offset="200">
            <div slot="loading" class="loading_box_bottom">
              <div class="bottom_load">
                <img src="../../assets/images/loading.gif" alt="">
                <div>加载中...</div>
              </div>
            </div>
            <customListView :arraydata="commentList" @itemClick="Details" @bigPictureLook="BigPictureLook" @itemDianZan="itemDianZan" @itemReply="itemReply">
            </customListView>
          </van-list>
        </div>
        <div class="list-no" v-if="CommentNum === 0">
          <p>来发表第一条评论吧~</p>
        </div>
        <div class="btn">
          <van-button color="#2EBA73" @click="Write()">
            <van-image :src="jiaIcon" width="14px" height="14px"></van-image>
            写点评
          </van-button>
        </div>
      </div>
    </div>
    <!-- 写评论 -->
    <div>
      <writeComment ref="writeComment" @Fb="Fb(arguments)" id="modalId"></writeComment>
    </div>
    <div>
      <DeleteDialog ref="deletedialog" @deleteBtn="CommentDeleteBtn()"></DeleteDialog>
    </div>
    <!-- 评论图片放大 -->
    <div>
      <displayimage ref="displayimage"></displayimage>
    </div>
  </div>
</template>
<script>
import Loading from "@/components/loading";
import qs from "qs";
import writeComment from "@/components/writeComment.vue";
import displayimage from "@/components/displayImage.vue";
import DeleteDialog from "@/components/deleteDialog.vue";
import customListView from "@/components/customListViewComment.vue";
export default {
  data() {
    return {
      headerUrl: require("../../assets/iconImage/my_moren@3x.png"),
      loading: true,
      publishShow: true,
      jiaIcon: require("../../assets/iconImage/ic_jia@3x.png"),
      //评论列表
      commentList: [],
      // 删除
      comment_id: "",
      galleryVosList: [],
      CommentNum: "", // 评论条数

      listLoading: false,
      finished: false,
      page: "", // 当前页数
      page_size: "10", // 页面条数
      uid: this.$cookie.get('w_uid'),
      parentId: null,
      type: null
    };
  },
  components: {
    Loading,
    DeleteDialog,
    writeComment,
    displayimage,
    customListView,
  },
  mounted() {
    this.type = this.$route.query.type;  // 列表数据的类型来源
    this.getCommentList();

  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getCommentList() {
      this.listLoading = true;
      if (this.commentList.length > 0) {
        var item = this.commentList[this.commentList.length - 1];
        this.page = item.comment_id;
      }
      let formData = new FormData();
      formData.append('cid', this.$route.query.cid);
      formData.append('comment_id', this.page);
      formData.append('page_size', this.page_size);
      formData.append('type', this.type);
      this.$request
        .post("/appserver/v1/comment/tyrantlist", formData)
        .then((data) => {
          this.loading = false;
          if (data.data.ret == 0) {
            let listdata = data.data.data.list;
            if (listdata) {
              if (listdata.length > 0) {
                // 问题回答列表
                this.commentList = this.commentList.concat(listdata);
              }
            }
            if (this.commentList.length >= data.data.data.comment_num) {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
          this.listLoading = false;
        });
    },
    CommentDeleteBtn() {
      event.stopPropagation();
      let data = {
        comment_id: this.comment_id,
        number: 2,
      };
      this.$request
        .post(`/appserver/v1/comment/deleteOrUp`, JSON.stringify(data))
        .then((data) => {
          if (data.data.ret === 0) {
            this.$refs.deletedialog.isDeleteShow = false;
            var index = 0;
            for (let key in this.commentList) {
              if (this.commentList[key].comment_id === this.comment_id) {
                index = key;
                break;
              }
            }
            this.commentList.splice(index, 1);
            this.$toast("删除成功");
          } else {
            this.$toast(data.data.msg);
          }
        });
    },
    // 评论删除
    CommentDelete(id) {
      event.stopPropagation();
      if (this.uid) {
        this.$refs.deletedialog.isDeleteShow = true;
        this.comment_id = id;
      } else {
        this.wxAuth();
      }
    },
    // 图片点击放大
    BigPictureLook(item, index, dataItem) {
      let imageArr = [];
      for (let i = 0; i < item.length; i++) {
        if (item[i].checkRet == 1 && dataItem.uid != this.uid) { // 非法图片
          // imageArr.push('');
        } else {
          imageArr.push(item[i].data);
        }
      }
      // console.log(item,'index')
      this.$refs.displayimage.showBigPictureLook(imageArr, index);


    },
    // 写评论
    Write() {
      this.parentId = null;
      // eslint-disable-next-line
      var u = navigator.userAgent,
        // eslint-disable-next-line
        app = navigator.appVersion;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        this.wxAuth();
      }
    },
    // 发表
    Fb(msg) {
      var message = msg[0];
      var gallerysStr = msg[1];
      let fromData = new FormData();
      fromData.append('content', message);
      fromData.append('cid', this.$route.query.cid);
      fromData.append('ctitle', document.title);
      fromData.append('type', this.type);
      fromData.append('source_type', 'h5');
      fromData.append('image', gallerysStr);

      if (this.parentId) {
        fromData.append('parent_id', this.parentId);
      }
      this.$request
        .post(`/appserver/v1/comment/addComment`, (fromData), {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          console.log(data, '123123123123123');
          if (data.data.ret == 0) {
            if (this.parentId) {
              this.$toast("回复成功");
              this.commentList = [];
              this.page = '';
              this.loading = true;
              this.finished = false;
              this.getCommentList();
            } else {
              this.$toast("发布成功");
              this.commentList = [];
              this.page = '';
              this.loading = true;
              this.finished = false;
              this.getCommentList();
            }
            // this.getCommentList();
            this.$refs.writeComment.ClosePost();
          } else {
            this.$refs.writeComment.ClosePost();
            if (data.data.msg == 'uid不能为空' || data.data.msg == '缺少uid请登录') {
              this.wxAuth();
            } else {
              this.$toast(data.data.msg);
            }
          }
        });
    },
    itemDianZan(item, commId) {
      let data = {
        comment_id: commId,
        number: "1",
      };
      let fromData = new FormData();
      fromData.append('comment_id', commId);
      fromData.append('number', 1);
      this.$request
        .post(`/appserver/v1/comment/deleteOrUp`, fromData, {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          if (data.data.ret === 0) {
            item.up++;
            item.is_up = !item.is_up;
          } else {
            if (data.data.msg == '缺少uid请登录') {
              this.wxAuth();
            } else {
              this.$toast(data.data.msg);

            }
          }
        });
    },
    /**
     * 回复
     * @params item 回复的评论item commId  回复的commitId
     */
    itemReply(item, commId) {
      console.log('回复');
      console.log(item, '回复item');
      console.log(commId, '回复commID');
      this.parentId = commId;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        this.wxAuth();
      }
    },
    // 评论详情
    Details(item) {
      // window.wii.app.invoke("openWindow", {
      //   openUrl: `${this.domain}discussDetails?comment_id=${item.comment_id}`,
      //   isFullScreen: 0,
      //   setTitle: "评论详情",
      //   needLoading: 1
      // });
      this.$router.push({
        path: "/discussDetails",
        query: {
          comment_id: item.comment_id,
          type: this.type,
          from: "web",
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.van-nav-bar__left {
  left: 14px;
}
.all-discuss-list {
  width: 100%;
  height: 100%;
  /deep/ .van-loading {
    width: 100%;
    margin-top: 30px;
    text-align: center;
  }
  .header {
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: #fff;
    z-index: 1200;
    /deep/ .van-icon {
      color: #000;
      font-size: 20px;
    }
    /deep/ .van-hairline--bottom::after {
      border: 0px;
    }
  }
  .comment-box {
    padding: 20px;
    // padding-top: 46px;
    .comment-list {
      padding-bottom: 80px;
      .loading_box_bottom {
        .bottom_load {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          color: #787878;
          img {
            width: 20px;
            height: 20px;
            margin-right: 2px;
          }
        }
      }
    }
    .list-no {
      text-align: left;
      // padding: 30px 0px 0px 0px;
      & > p {
        height: 14px;
        font-size: 15px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;
      }
    }
    .btn {
      position: fixed;
      bottom: 0px;
      left: 0px;
      width: 100%;
      padding: 20px;
      background: #fff;
      box-sizing: border-box;
      /deep/ .van-image {
        margin-right: 4px;
        margin-top: -3px;
      }
      /deep/ .van-button {
        width: 100%;
        border: 0px;
        height: 40px;
        // background: #2EBA73;
      }
      /deep/ .van-button span {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        /deep/ .van-icon {
          color: #fff;
          margin-right: 7px;
        }
      }
      /deep/ .van-icon {
        color: #fff;
        margin-right: 7px;
      }
    }
  }
}
@media screen and (max-width: 360px) {
  .all-discuss-list
    .comment-box
    .comment-list
    .list-item
    .right
    > div
    .images
    .van-image {
    height: 90px !important;
  }
}
@media screen and (max-width: 350px) {
  .all-discuss-list
    .comment-box
    .comment-list
    .list-item
    .right
    > div
    .images
    .van-image {
    height: 88px !important;
  }
}
@media screen and (max-width: 340px) {
  .all-discuss-list
    .comment-box
    .comment-list
    .list-item
    .right
    > div
    .images
    .van-image {
    height: 86px !important;
  }
}
@media screen and (max-width: 330px) {
  .all-discuss-list
    .comment-box
    .comment-list
    .list-item
    .right
    > div
    .images
    .van-image {
    height: 80px !important;
  }
}
</style>
